import React, { createContext, useState, useContext } from "react";

interface NotificationContextType {
  notificationCount: number;
  shiftCount: number;
  shiftAcceptedCount: number;
  openShiftCount: number;
  openShiftAcceptedCount: number;
  confirmShiftCount: number;
  documentCount: number;
  swapRequestCount: number;
  leaveRequestCount: number;
  postCount: number;
  postLink: string;
  shiftLink: string;
  openShiftLink : string;
  confirmShiftLink: string;
  setNotificationCount: React.Dispatch<React.SetStateAction<number>>;
  setShiftCount: React.Dispatch<React.SetStateAction<number>>;
  setShiftAcceptedCount: React.Dispatch<React.SetStateAction<number>>;
  setOpenShiftCount: React.Dispatch<React.SetStateAction<number>>;
  setOpenShiftAcceptedCount: React.Dispatch<React.SetStateAction<number>>;
  setConfirmShiftCount: React.Dispatch<React.SetStateAction<number>>;
  setDocumentCount: React.Dispatch<React.SetStateAction<number>>;
  setSwapRequestCount: React.Dispatch<React.SetStateAction<number>>;
  setLeaveRequestCount: React.Dispatch<React.SetStateAction<number>>;
  setPostCount: React.Dispatch<React.SetStateAction<number>>;
  setPostLink: React.Dispatch<React.SetStateAction<string>>;
  setShiftLink: React.Dispatch<React.SetStateAction<string>>;
  setOpenShiftLink: React.Dispatch<React.SetStateAction<string>>;
  setConfirmShiftLink: React.Dispatch<React.SetStateAction<string>>;
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export const NotificationProvider = ({ children }: any) => {
    const [notificationCount, setNotificationCount] = useState(0);
    const [shiftCount, setShiftCount] = useState(0);
    const [shiftAcceptedCount, setShiftAcceptedCount] = useState(0);
    const [openShiftCount, setOpenShiftCount] = useState(0);
    const [openShiftAcceptedCount, setOpenShiftAcceptedCount] = useState(0);
    const [confirmShiftCount, setConfirmShiftCount] = useState(0);
    const [documentCount, setDocumentCount] = useState(0);
    const [swapRequestCount, setSwapRequestCount] = useState(0);
    const [leaveRequestCount, setLeaveRequestCount] = useState(0);
    const [postCount, setPostCount] = useState(0);
    const [postLink, setPostLink] = useState("");
    const [shiftLink, setShiftLink] = useState("");
    const [openShiftLink, setOpenShiftLink] = useState("");
    const [confirmShiftLink, setConfirmShiftLink] = useState("");

    return (
        <NotificationContext.Provider value={{ 
            notificationCount, setNotificationCount,
            shiftCount, setShiftCount,
            shiftAcceptedCount, setShiftAcceptedCount,
            openShiftCount, setOpenShiftCount,
            openShiftAcceptedCount, setOpenShiftAcceptedCount,
            confirmShiftCount, setConfirmShiftCount,
            documentCount, setDocumentCount,
            swapRequestCount, setSwapRequestCount,
            leaveRequestCount, setLeaveRequestCount,
            postCount, setPostCount,
            postLink, setPostLink,
            shiftLink, setShiftLink,
            openShiftLink, setOpenShiftLink,
            confirmShiftLink, setConfirmShiftLink
            }}>
        {children}
        </NotificationContext.Provider>
    );
};

export const useNotification = () => useContext(NotificationContext);
